import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Field, Form } from 'formik';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import FormikErrorFocus from "formik-error-focus";
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useDispatch, useSelector } from 'react-redux';
import { roles } from "../../utils/constants";
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton, SlOption, SlSelect } from '@shoelace-style/shoelace/dist/react';
import filterSvg from '../../assets/images/filter.svg'
import { ScrollContainer } from "react-indiana-drag-scroll";

function Requests() {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState("")
    const [currentPage, setCurrentPage] = useState(0);
    const [status, setStatus] = useState("0");
    const [type, setType] = useState("-1")
    const [showFilter, setShowFilter] = useState(false)

    const statuses = [
        {
            value: "all",
            label: "All",
        },
        {
            value: "0",
            label: "Queued",
        },
        {
            value: "1",
            label: "Approved",
        },
        {
            value: "2",
            label: "Rejected",
        }
    ];

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }
    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        // loadData(e.target.value, 0);
    }
    const changeSelectHandler = (event) => {
        setStatus(event.target.value);
        setCurrentPage(0);
        // loadData(search, 0, event.target.value, -1);
    };

    const changeTypeHandler = (event) => {
        setType(event.target.value);
        setStatus("0");
        setCurrentPage(0);
        // loadData(search, 0, 0, event.target.value);
    };
    const handleApprove = async (contact_id, sales_id, request_id) => {
        try {
            let res = await api({
                url: `/b2b_requests/approve/${contact_id}`,
                method: "PUT",
                responseType: "json",
                data: {
                    contact_id,
                    sales_id,
                    request_id
                }
            })
            if (res?.code !== 200) {
                toast.error(res?.data?.message);
                loadData(search, 0);
            } else {
                toast.success("Request approved Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData(search, 0);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const handleReject = async (contact_id, sales_id, request_id) => {
        try {
            let res = await api({
                url: `/b2b_requests/reject/${contact_id}`,
                method: "PUT",
                responseType: "json",
                data: {
                    contact_id,
                    sales_id,
                    request_id
                }
            })
            if (res?.code !== 200) {
                toast.error(res?.data?.message);
                loadData(search, 0);
            } else {
                toast.success("Request rejected Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData(search, 0);
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const handleBlock = async (contact_id, sales_id, request_id) => {
        try {
            await api({
                url: `/b2b_requests/block/${contact_id}`,
                method: "PUT",
                responseType: "json",
                data: {
                    contact_id,
                    sales_id,
                    request_id
                }
            })
            toast.success("Request blocked Successfully");
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadData = async (searchString = '', page = 0, status = 0, type = -1) => {
        try {
            if (localStorage.getItem("role") === roles.b2b) {
                setLoader(true);
                let res = await api({
                    url: `/b2b_requests/get`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        page,
                        limit: 100,
                        search: searchString,
                        type: parseInt(type),
                        status: parseInt(status)
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setData(res.data.data.length ? res.data.data : [])
                    // setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
                    setTotalPages(Math.ceil(res.data.total / 100));
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }
    // useEffect(() => {
    //     loadData()
    // }, []);
    useEffect(() => {
        if (localStorage.getItem("role") === roles.b2b) {
            loadData(search, currentPage, status, type);
        }
    }, [search, currentPage, status, type]);
    return (
        <>
            <div className="flex items-center mb-3">
                <h5>Requests</h5>
                <aside className="flex items-center mobHide gap-3 ml-auto">
                    <div>
                        <SlSelect
                            value={type}
                            size="medium"
                            placeholder="Select Type"
                            onSlChange={changeTypeHandler}>
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="-1">All</SlOption>
                            <SlOption value="0">Agency Data</SlOption>
                            <SlOption value="1">B2B Data</SlOption>
                            <SlOption value="2">Competitor Data</SlOption>

                        </SlSelect>
                    </div>
                    <div>
                        <SlSelect
                            value={status}
                            size="medium"
                            placeholder="Select Status"
                            onSlChange={changeSelectHandler}>
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="0">Queued</SlOption>
                            <SlOption value="1">Approved</SlOption>
                            <SlOption value="2">Rejected</SlOption>

                        </SlSelect>
                    </div>
                    <div className="ml-auto">
                        <SlInput
                            size="medium"
                            id="myInput"
                            onSlInput={debounce(searchData, 500)}
                            placeholder="Search by Name / Designation / Company">
                            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                        </SlInput>
                    </div>
                </aside>
                <img src={filterSvg} alt='filter' className='w-6  mobileOnly ml-auto' onClick={() =>{setShowFilter(true)}} ></img>
            </div>

            < div className='mb-4' >
                <ScrollContainer>
                <table className='table table-bordered'>
                    <thead className="sticky top-0 ">
                        <tr>
                            <th >Name</th>
                            <th>Designation</th>
                            <th >Company</th>
                            <th>Contact Type</th>
                            <th>Requested On</th>
                            <th >Requested By</th>
                            <th>Requested From</th>
                            {(parseInt(status) === 0) ? (<th>Actions</th>) : null}
                        </tr>
                    </thead>
                    {(data?.length && !loader) ? (
                        <tbody>
                            {data.map((item) => {
                                return (
                                    < tr key={item.request_id} className="group/details hover:bg-slate-100" >
                                        <th scope='row' >{item.name}</th>
                                        <td>{item.designation}</td>
                                        <td>{item.company || '-'}</td>
                                        {(item.type === 0) ? (<td>{"Agency"}</td>) : ((item.type === 1) ? (<td>{"B2B"}</td>) : (<td>{"Competitor"}</td>))}
                                        <td>{formatDateWithTime(item.created_on)}</td>
                                        <td>{item.requested_by || "-"}</td>
                                        <td>{item.locationName || '-'}</td>
                                        {(item.status === 0) ? (<td >
                                            <div className='inline-flex gap-3'>
                                                {(localStorage.getItem("role") === roles.b2b) ?
                                                    (<button type="button" class="btn btn-success" onClick={() => { handleApprove(item.contact_id, item.sales_id, item.request_id) }} >Approve</button>)
                                                    : null}
                                                {(localStorage.getItem("role") === roles.b2b) ? (<button type="button" class="btn btn-danger" onClick={() => { handleReject(item.contact_id, item.sales_id, item.request_id) }}>Reject</button>) : null}
                                            </div>
                                        </td>) : null}
                                    </tr>
                                )
                            })}
                        </tbody>) : ((!data?.length && !loader)
                            ? <NoDataFound colspan="8" />
                            : <TableLoader colspan="8" />
                    )
                    }
                </table>
                </ScrollContainer>
            </div >
            <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <aside className="flex items-center gap-3 flex-wrap-reverse">
                    <div className='w-full'>
                        <SlSelect
                            value={type}
                            size="medium"
                            placeholder="Select Type"
                            onSlChange={changeTypeHandler}>
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="-1">All</SlOption>
                            <SlOption value="0">Agency Data</SlOption>
                            <SlOption value="1">B2B Data</SlOption>
                            <SlOption value="2">Competitor Data</SlOption>

                        </SlSelect>
                    </div>
                    <div className='w-full'>
                        <SlSelect
                            value={status}
                            size="medium"
                            placeholder="Select Status"
                            onSlChange={changeSelectHandler}>
                            <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
                            <SlOption value="0">Queued</SlOption>
                            <SlOption value="1">Approved</SlOption>
                            <SlOption value="2">Rejected</SlOption>

                        </SlSelect>
                    </div>
                    <div className="w-full">
                        <SlInput
                            size="medium"
                            id="myInput"
                            onSlInput={debounce(searchData, 500)}
                            placeholder="Search by Name / Designation / Company">
                            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                        </SlInput>
                    </div>
                </aside>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
        </>
    )
}
export default Requests